import {
    FETCH_ASSOCIATED_PARTIES_DATA_REQUEST,
    UPDATE_ASSOCIATED_PARTIES_DATA_REQUEST,
    FETCH_CREATE_PARTY_DATA_REQUEST,
    FETCH_PARTY_INFO_REQUEST,
    FETCH_PARTY_SUGGESTION_REQUEST,
    ADD_ASSOCIATE_PARTY_REQUEST,
    DELETE_ASSOCIATE_PARTY_REQUEST,
    CHANGE_LOG_ASSOCIATE_PARTY_REQUEST,
    SAVE_ASSOCIATED_PARTY,
    RESET_PARTY_SUGGESTIONS,
    RESET_ASSOCIATED_PARTIES,
    EDIT_PARTY_REQUEST,
    RESET_EDIT_PARTY_DATA,
    SET_PARTY_ASSOCIATION,
    FETCH_PARTY_STATES_REQUEST,
    UPDATE_CONTACT_RELATIONSHIP_REQUEST,
    FETCH_CARRIER_LIST

} from './actionConstants';

export const fetchAssocitedPartiesData = payload => ({
    type: FETCH_ASSOCIATED_PARTIES_DATA_REQUEST,
    payload
})

export const updateAssociatedPartiesData = payload => ({
    type:UPDATE_ASSOCIATED_PARTIES_DATA_REQUEST,
    payload
})

export const updateContactRelationshipType = payload => ({
    type:UPDATE_CONTACT_RELATIONSHIP_REQUEST,
    payload
})

export const resetAssociatedParties = payload => ({
    type:RESET_ASSOCIATED_PARTIES,
    payload
})

export const fetchCreatePartyData = payload => ({
    type: FETCH_CREATE_PARTY_DATA_REQUEST,
    payload
})

export const fetchCarrierLists = payload => ({
    type: FETCH_CARRIER_LIST,
    payload
})

export const fetchPartyInfo = payload => ({
    type: FETCH_PARTY_INFO_REQUEST,
    payload
})

export const fetchPartyStates = payload => ({
    type: FETCH_PARTY_STATES_REQUEST,
    payload
})

export const fetchPartySuggestions = payload => ({
    type: FETCH_PARTY_SUGGESTION_REQUEST,
    payload
})

export const addAssociateParty = payload => ({
    type: ADD_ASSOCIATE_PARTY_REQUEST,
    payload
})

export const deleteAssociateParty = payload => ({
    type: DELETE_ASSOCIATE_PARTY_REQUEST,
    payload
})

export const changePartiesLog = payload => ({
    type: CHANGE_LOG_ASSOCIATE_PARTY_REQUEST,
    payload
})

export const saveAssociatedParty = payload => ({
    type: SAVE_ASSOCIATED_PARTY,
    payload
})

export const resetPartySuggestions = payload => ({
    type: RESET_PARTY_SUGGESTIONS,
    payload
})

export const editAssociatedParty = payload => ({
    type: EDIT_PARTY_REQUEST,
    payload
})

export const resetEditPartyData = () => ({
    type: RESET_EDIT_PARTY_DATA 
})

export const setPartyAssociation = (payload) => ({
    type: SET_PARTY_ASSOCIATION,
    payload
})